import "./polyfill"

import { ForecastTableElevation } from "components/forecast-table-elevation"
import { Leaflet } from "components/leaflet"
import { ScrollContainer } from "components/scroll-container"
import { SignUp } from "components/signup"
import { Smartbar } from "components/smartbar"
import { SnowAmount } from "components/snow-amount"
import { TempValue } from "components/temp-value"
import { WindIcon } from "components/wind-icon"
import ForecastTable from "components/forecast-table"
import gallerySortLinks from "components/gallery-sort-links/gallery_sort_links"
import scrollFade from "components/scroll-fade"
import sticky from "components/sticky"
import initSwitchUnits from "components/switch-units"
import initTooltip from "components/tooltips"
import tshirts from "components/tshirts/tshirts"
import "components/gallery-photo-upload/gallery_photo_upload"
import "components/location_summary/location_summary"
import "components/issued/issued"
import "components/weather-icon"
import "components/weather-icon"
import "components/stories/stories"
import "components/latlong/latlong"
import "components/panorama/panorama"
import "components/app-store"
import "components/store-badges"
import "components/h1-title"
import "components/bike-park-info"
import "components/bike-park-header"
import "components/incentive"
import { Banner } from "components/questionnaire-banner"
import "components/buttons"
import "components/app-buttons"
import "components/outside-buttons"
import "components/apple-buttons"
import "components/google-buttons"
import "components/login"
import { Signup } from "components/signup-page"
import { TabNavigationComponent } from "components/profile"
import { PageHeader } from "components/page-header"
import "components/page-footer"
import "components/homepage-hero"
import "components/user-avatar"
import "components/promo-premium"
import "components/promo-app"
import "components/guide"
import { AccordionReviews } from "components/accordion-reviews"
import "components/outside-promo-page"
import "components/outside-page"
import "components/carousel-nearby-mountains"
import "components/carousel-news-posts"
import "components/carousel-photo-gallery"
import "components/carousel-popular-mountains"
import { LocationSearch } from "components/location-search"
import "components/homepage-footer"

import init from "init/application"

import isBnInViewport from "utils/ad-refresh"

// eslint-disable-next-line import/first, import/no-unresolved
import "fc-ads/fc-ads.scss"

require.context("static", true, /\.(png|jpg|svg)$/)

window.WindIcon = WindIcon
window.TempValue = TempValue

function onDOMLoad() {
  init()
  scrollFade()
  WindIcon.init(document)
  TempValue.init(document)
  new SignUp(null)
  Banner.init(document.body)
  Signup.init(document.body)
  TabNavigationComponent.init(document.body)
  PageHeader.init(document.body)
  LocationSearch.init(document.body)
}

function onWindowLoad() {
  initSwitchUnits()
  ForecastTable()
  tshirts()
  gallerySortLinks()
  initTooltip()
  sticky()

  ScrollContainer.init(document.body)
  SnowAmount.init(document.body)
  Smartbar.init(document.body)
  ForecastTableElevation.init(document.body)
  AccordionReviews.init(document.body)

  if (window.FCGON && window.FCGON.maps) {
    Leaflet.init(document.body, window.FCGON.maps)
  }
}

window.isBnInViewport = isBnInViewport

// `DOMContentLoaded` may fire before your script has a chance to onDOMLoad, so check before adding a listener
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onDOMLoad)
} else {
  onDOMLoad()
}

if (document.readyState === "loading" || document.readyState === "interactive") {
  window.addEventListener("load", onWindowLoad)
} else {
  onWindowLoad()
}
